import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import SessionsPage from "@/pages/SessionsPage";
import StudioPage from "@/pages/StudioPage";
import EquipmentPage from "@/pages/EquipmentPage";
import ComprehensivePage from "@/pages/ComprehensivePage";
import PricingPage from "@/pages/PricingPage";
import FAQPage from "@/pages/FAQPage";
import BookingsPage from "@/pages/BookingsPage";
import ContactPage from "@/pages/ContactPage";
import ComingSoonPage from "@/pages/ComingSoonPage";

// Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services/sessions" element={<SessionsPage />} />
        <Route path="/services/studio" element={<StudioPage />} />
        <Route path="/services/equipment" element={<EquipmentPage />} />
        <Route path="/services/comprehensive" element={<ComprehensivePage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/bookings" element={<BookingsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </AnimatePresence>
  );
}

function MainApp() {
  return (
    <div className="App min-h-screen bg-stone-50">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main>
          <AnimatedRoutes />
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const auth = localStorage.getItem('tezr_authenticated');
    setIsAuthenticated(auth === 'true');
    setIsLoading(false);
  }, []);

  const handleAuthenticate = () => {
    setIsAuthenticated(true);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-stone-300 border-t-stone-900 rounded-full animate-spin" />
      </div>
    );
  }

  // Show Coming Soon page if not authenticated
  if (!isAuthenticated) {
    return <ComingSoonPage onAuthenticate={handleAuthenticate} />;
  }

  // Show main app if authenticated
  return <MainApp />;
}

export default App;
